import { BaseDto } from "./base.dto";

export class CorporateCardDto extends BaseDto {
    name: string;
    email: string;
    amount: number;
    cardNumber: string;
}